export default __webpack_public_path__ + "static/xandor-de5262b0a5b55be3ddc80b227b830919.jpg";